@if (wrapInListItem()) {
  @for (item of counter(count()); track $index) {
    <li class="tender-card-skeleton__list-item">
      <div class="tender-card-skeleton">
        <div class="tender-card-skeleton__header">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '5.5rem',
              height: '1.75em',
              'border-radius': '0.375rem',
              margin: '0',
            }"></ngx-skeleton-loader>
          <div class="tender-card-skeleton__budget">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '4.5rem',
                height: '0.875em',
                'border-radius': '0.25rem',
                margin: '0',
              }"></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '5rem',
                height: '1.125em',
                'border-radius': '0.25rem',
                margin: '0',
              }"></ngx-skeleton-loader>
          </div>
        </div>

        <ngx-skeleton-loader
          count="1"
          class="tender-card-skeleton__title"
          [theme]="{
            width: '88%',
            height: '1.25em',
            'border-radius': '0.25rem',
            margin: '0',
          }"></ngx-skeleton-loader>

        <div class="tender-card-skeleton__divider"></div>

        <div class="tender-card-skeleton__requirement-box">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '0.875em',
              'border-radius': '0.25rem',
              margin: '0',
            }"></ngx-skeleton-loader>
        </div>

        <div class="tender-card-skeleton__actions">
          <ngx-skeleton-loader
            count="1"
            class="tender-card-skeleton__cta"
            [theme]="{
              width: '6.5rem',
              height: '1em',
              'border-radius': '0.25rem',
              margin: '0',
            }"></ngx-skeleton-loader>
        </div>
      </div>
    </li>
  }
} @else {
  <div [ngClass]="containerClasses()">
    @for (item of counter(count()); track $index) {
      <div class="tender-card-skeleton">
        <div class="tender-card-skeleton__header">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '5.5rem',
              height: '1.75em',
              'border-radius': '0.375rem',
              margin: '0',
            }"></ngx-skeleton-loader>
          <div class="tender-card-skeleton__budget">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '4.5rem',
                height: '0.875em',
                'border-radius': '0.25rem',
                margin: '0',
              }"></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '5rem',
                height: '1.125em',
                'border-radius': '0.25rem',
                margin: '0',
              }"></ngx-skeleton-loader>
          </div>
        </div>

        <ngx-skeleton-loader
          count="1"
          class="tender-card-skeleton__title"
          [theme]="{
            width: '88%',
            height: '1.25em',
            'border-radius': '0.25rem',
            margin: '0',
          }"></ngx-skeleton-loader>

        <div class="tender-card-skeleton__divider"></div>

        <div class="tender-card-skeleton__requirement-box">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '100%',
              height: '0.875em',
              'border-radius': '0.25rem',
              margin: '0',
            }"></ngx-skeleton-loader>
        </div>

        <div class="tender-card-skeleton__actions">
          <ngx-skeleton-loader
            count="1"
            class="tender-card-skeleton__cta"
            [theme]="{
              width: '6.5rem',
              height: '1em',
              'border-radius': '0.25rem',
              margin: '0',
            }"></ngx-skeleton-loader>
        </div>
      </div>
    }
  </div>
}
